// extracted by mini-css-extract-plugin
module.exports = {"SectionCard2":"SectionCard2_SectionCard2__kBz26"};